import React from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcInput,
  DcText,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { createOrderStatus, updateOrderStatus } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const AddNewStatusForm = (props) => {
  const { defaultStatuses, handleClose, editingStatus } = props
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [data, setData] = React.useState({
    status_name: '',
    default_status_id: '',
    show_in_highlights: 0,
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()

    if (editingStatus) {
      handleUpdateStatus()
    } else {
      handleAddStatus()
    }
  }
  const handleUpdateStatus = () => {
    showPageLoader()
    const settings = {
      default_status_id: data.default_status_id,
      show_in_highlights: editingStatus.show_in_highlights,
      status_id: editingStatus.status_id,
      status_name: data.status_name,
    }

    updateOrderStatus(settings).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully updated')
        setData({
          status_name: res.response.data.status_name,
          default_status_id: res.response.data.default_status_id,
          show_in_highlights: res.response.data.show_in_highlights,
        })
        handleClose(res.response.data, 'update')
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }
  React.useEffect(() => {
    if (editingStatus) {
      setData({
        ...data,
        ...editingStatus,
        default_status_id: editingStatus.ems_status_id,
        status_name: editingStatus.status_label,
      })
    }
  }, [editingStatus])
  const handleAddStatus = () => {
    showPageLoader()
    createOrderStatus(data).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully Added')
        setData({
          status_name: res.response.data.status_name,
          default_status_id: res.response.data.default_status_id,
          show_in_highlights: res.response.data.show_in_highlights,
        })
        handleClose(res.response.data, 'add')
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          flexDirection="row"
          width="100%"
          height="auto"
          gap="10px"
          style={{ flexGrow: '1' }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Status Name
            </DcText>
            <DcInput
              tabIndex={1}
              error={
                error.field === 'status_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Status Name'}
              placeholder={'Status Name'}
              value={data.status_name}
              onChange={(e) =>
                setData({ ...data, status_name: e.target.value })
              }
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          width="100%"
          height="auto"
          gap="10px"
          style={{ flexGrow: '1' }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Default Status
            </DcText>
            <DcDropDown
              tabIndex={2}
              error={
                error.field === 'default_status_id' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              placeholder={'Default Status'}
              options={[
                {
                  status_label: 'Select Default Status',
                  default_status_id: '',
                },
                ...defaultStatuses,
              ].map((status) => ({
                label: status.status_label,
                value: status.default_status_id,
              }))}
              value={data.default_status_id}
              onChange={(e) => {
                setData({ ...data, default_status_id: e.target.value })
              }}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          width="100%"
          height="auto"
          gap="10px"
          style={{ flexGrow: '1' }}
          justifyContent="flex-end"
        >
          <DcButton
            variant="primary"
            type="submit"
            tabIndex={3}
            withIcon={true}
            size="sm"
          >
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default AddNewStatusForm
